import React from 'react';
import PropTypes from 'prop-types';
import { motion, useTransform } from 'framer-motion';
import useWindowSize from 'hooks/useWindowSize';
import Bird from 'products/global/assets/img/home/bird.png';
import ArrowRight from 'assets/img/icons/arrow-right.svg';
import history from 'routing/history';
import {
  PlatformsWrapper,
  Platform,
  Title,
  Description,
  NomadInsuranceSignup,
  RemoteHealthSignup,
  BirdContainer,
  BirdImg,
  PlatformsBackground,
  ProductButton,
  ProductText,
  ProductArrow
} from './styled';

const Platforms = ({
  platformsControls,
  birdControls,
  roadX,
  roadY,
  allAnimationsFinished
}) => {
  const { width: windowWidth } = useWindowSize();

  const birdX = useTransform(roadX, (val) => val * -0.3);
  const birdY = useTransform(roadY, (val) => val * -0.5);

  const birdVariants = {
    start: {
      y: window.innerHeight,
      opacity: 0
    },
    finish: {
      y: 0,
      opacity: 1,
      transition: {
        delay: 0.5,
        y: {
          type: 'spring',
          damping: 300,
          stiffness: 200,
          restSpeed: 100,
          restDelta: 100
        }
      }
    }
  };

  return (
    <PlatformsWrapper>
      <Platform product="Nomad Insurance">
        <motion.div
          variants={{
            hidden: { y: 40, opacity: 0 },
            visible: { y: 0, opacity: 1, transition: { duration: 0.5, delay: 0.2 } }
          }}
          animate={platformsControls}
          initial="hidden"
        >
          <Title>
            {windowWidth > 500 && (
              <>
                Insurance for
                <br />
                nomads
              </>
            )}
            {windowWidth <= 500 && (
              <>
                Insurance
                <br />
                for nomads
              </>
            )}
          </Title>
          <Description>
            {windowWidth > 500 && (
              <>
                Nomad Insurance is a global travel medical insurance that covers people
                from all over the world, while outside their home country. You can buy it
                even if you are already abroad.
              </>
            )}
            {windowWidth <= 500 && (
              <>
                Global travel medical insurance that covers people from all over the
                world.
              </>
            )}
          </Description>

          <NomadInsuranceSignup onClick={() => history.push('/nomad-insurance/signup')}>
            Sign up
          </NomadInsuranceSignup>

          <ProductButton onClick={() => history.push('/nomad-insurance')}>
            <ProductText>Go to Nomad Insurance</ProductText>
            <ProductArrow>
              <div />
              <img src={ArrowRight} alt="arrow-right" />
            </ProductArrow>
          </ProductButton>
        </motion.div>
      </Platform>
      <BirdContainer>
        <BirdImg
          src={Bird}
          alt="bird waving"
          variants={birdVariants}
          animate={birdControls}
          style={allAnimationsFinished ? { x: birdX, y: birdY } : null}
          initial="start"
          transition={{ type: 'spring' }}
        />
      </BirdContainer>
      <Platform product="Remote Health">
        <motion.div
          variants={{
            hidden: { y: 40, opacity: 0 },
            visible: { y: 0, opacity: 1, transition: { duration: 0.5, delay: 0.2 } }
          }}
          animate={platformsControls}
          initial="hidden"
        >
          <Title>
            {windowWidth > 500 && (
              <>
                Insurance for
                <br />
                remote teams
              </>
            )}
            {windowWidth <= 500 && (
              <>
                Insurance for
                <br />
                remote teams
              </>
            )}
          </Title>
          <Description>
            {windowWidth > 500 && (
              <>
                Remote Health is a global health insurance to cover your employees and
                contractors worldwide under one plan, regardless of where they live. Add
                or remove members through a user friendly dashboard.
              </>
            )}
            {windowWidth <= 500 && (
              <>
                Health insurance to cover employees and contractors worldwide under one
                plan.
              </>
            )}
          </Description>

          <RemoteHealthSignup
            onClick={() => {
              const win = window.open(
                'https://hello.safetywing.com/lets-connect',
                '_blank'
              );
              win.focus();
            }}
          >
            Sign up
          </RemoteHealthSignup>

          <ProductButton
            onClick={() =>
              window.location.replace(`${process.env.REACT_APP_URL}/remote-health`)
            }
          >
            <ProductText>Go to Remote Health</ProductText>
            <ProductArrow>
              <div />
              <img src={ArrowRight} alt="arrow-right" />
            </ProductArrow>
          </ProductButton>
        </motion.div>
      </Platform>

      <PlatformsBackground
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { duration: 0.3 } }
        }}
        animate={platformsControls}
        initial="hidden"
      >
        <div />
        <div />
      </PlatformsBackground>
    </PlatformsWrapper>
  );
};

Platforms.propTypes = {
  platformsControls: PropTypes.object,
  birdControls: PropTypes.object,
  roadX: PropTypes.object,
  roadY: PropTypes.object,
  allAnimationsFinished: PropTypes.bool
};

export default Platforms;
